import React from 'react'
import { getDDMMYYYYFormat } from '../../../common/helpers/DateHandlers'
import { documentTypeDescriptions } from '../helpers/custumerEnum'

interface IProps {
  finalBeneficiary: any
}

export const FinalBeneficiaryCard = ({ finalBeneficiary }: IProps) => {
  return (
    <div className='card p-10'>
      <div className='d-flex justify-content-between align-items-center mb-5'>
        <h6 className='text-muted fs-4'>Beneficiario Final</h6>
        {/* <div
          onClick={() => $('#EditFinalBeneficiaryModal').modal('toggle')}
          className='iconButton cursor-pointer'
        >
          <i className='bi bi-pencil-square fs-3'></i>
        </div> */}
      </div>

      <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
        <thead>
          <tr className='fw-normal text-muted'>
            <th className='min-w-150px'>CAMPO</th>
            <th className='min-w-150px'>VALOR</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span className='text-muted fs-5'>NOMBRES</span>
            </td>
            <td>
              <span className='text-muted fs-5'>{finalBeneficiary.name_beneficiary ?? '--'}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span className='text-muted fs-5'>APELLIDOS</span>
            </td>
            <td>
              <span className='text-muted fs-5'>
                {finalBeneficiary.lastname_beneficiary ?? '--'}
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <span className='text-muted fs-5'>PAÍS DE RESIDENCIA</span>
            </td>
            <td>
              <span className='text-muted fs-5'>
                {finalBeneficiary?.country?.description ?? '--'}
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <span className='text-muted fs-5'>FECHA DE NACIMIENTO</span>
            </td>
            <td>
              <span className='text-muted fs-5'>
                {finalBeneficiary?.date_birth
                  ? getDDMMYYYYFormat(finalBeneficiary?.date_birth)
                  : '--'}
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <span className='text-muted fs-5'>NACIONALIDAD</span>
            </td>
            <td>
              <span className='text-muted fs-5'>
                {finalBeneficiary?.nationality?.description ?? '--'}
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <span className='text-muted fs-5'>TIPO DE DOCUMENTO</span>
            </td>
            <td>
              <span className='text-muted fs-5'>      {documentTypeDescriptions[finalBeneficiary?.document_type] ?? '--'}
</span>
            </td>
          </tr>
          <tr>
            <td>
              <span className='text-muted fs-5'>NÚMERO DE DOCUMENTO</span>
            </td>
            <td>
              <span className='text-muted fs-5'>{finalBeneficiary?.document_number ?? '--'}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span className='text-muted fs-5'>NIT</span>
            </td>
            <td>
              <span className='text-muted fs-5'>{finalBeneficiary?.nit || '--'}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span className='text-muted fs-5'>RUC</span>
            </td>
            <td>
              <span className='text-muted fs-5'>{finalBeneficiary?.ruc || '--'}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span className='text-muted fs-5'>ESTADO CIVIL</span>
            </td>
            <td>
              <span className='text-muted fs-5'>
                {finalBeneficiary?.civil_status?.description ?? '--'}
              </span>
            </td>
          </tr>

          {finalBeneficiary &&
            (finalBeneficiary?.civil_status?.id === 2 ||
              finalBeneficiary?.civil_status?.id === 5) && (
              <>
                <tr>
                  <td>
                    <span className='text-muted fs-5'>NOMBRE DEL CÓNYUGE</span>
                  </td>
                  <td>
                    <span className='text-muted fs-5'>{finalBeneficiary?.name_spouse ?? '--'}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className='text-muted fs-5'>APELLIDO DEL CÓNYUGE</span>
                  </td>
                  <td>
                    <span className='text-muted fs-5'>
                      {finalBeneficiary?.lastname_spouse ?? '--'}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className='text-muted fs-5'>TIPO DE DOCUMENTO DEL CÓNYUGE</span>
                  </td>
                  <td>
                    <span className='text-muted fs-5'>
                     {documentTypeDescriptions[finalBeneficiary?.document_type_spouse] ?? '--'}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className='text-muted fs-5'>NÚMERO DE DOCUMENTO DEL CÓNYUGE</span>
                  </td>
                  <td>
                    <span className='text-muted fs-5'>
                      {finalBeneficiary?.document_number_spouse ?? '--'}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>
                    <span className='text-muted fs-5'>REGIMEN PATRIMONIAL </span>
                  </td>
                  <td>
                    <span className='text-muted fs-5'>
                      {finalBeneficiary?.regime_type?.description ?? '--'}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>
                    <span className='text-muted fs-5'>FECHA </span>
                  </td>
                  <td>
                    <span className='text-muted fs-5'>
                      {finalBeneficiary?.date_property_regime
                        ? getDDMMYYYYFormat(finalBeneficiary?.date_property_regime)
                        : '--'}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>
                    <span className='text-muted fs-5'>CORREO ELECTRÓNICO</span>
                  </td>
                  <td>
                    <span className='text-muted fs-5'>
                      {finalBeneficiary?.contact_email ?? '--'}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className='text-muted fs-5'>NÚMERO TELEFÓNICO</span>
                  </td>
                  <td>
                    <span className='text-muted fs-5'>
                      {finalBeneficiary?.contact_phone ?? '--'}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className='text-muted fs-5'>DIRECCIÓN COMPLETA</span>
                  </td>
                  <td>
                    <span className='text-muted fs-5'>
                      {finalBeneficiary?.contact_address ?? '--'}
                    </span>
                  </td>
                </tr>
              </>
            )}
        </tbody>
      </table>
    </div>
  )
}
